export default __webpack_public_path__ + "static/media/book-bg.90f72513.jpg";